export default __webpack_public_path__ + "static/media/13.6ff4a895.PNG";